import { useEffect, useState } from "react";
import CourseHeadBlock from "../Components/Modules/CourseDescription/CourseHeadBlock";
import ModuleBlock from "../Components/Modules/CourseDescription/ModuleBlock";
import StageBlock from "../Components/Modules/CourseDescription/StageBlock";
import TrackBlock from "../Components/Modules/CourseDescription/TrackBlock";
import StyledButton from "../Components/UI/StyledButton";
import TestForm from "../Components/Modules/Test/TestForm";
import DirectusModuleInterface from "../Interfaces/DirectusModuleInterface";
import { useNavigate } from "react-router-dom";
import Login from "../Components/Modules/Autorization/Login";
import Collection from "../Api/ReadCollection";
import LoggedTestForm from "../Components/Modules/Test/LoggedTestForm";
import Registration from "../Components/Modules/Autorization/Registration";
import qr from "../Assets/Images/qr.svg";
import medal from "../Assets/Images/medal.svg";
import { directus } from "../Api/FetchDirectus";
import { readItems } from "@directus/sdk";

const CourseDescriptionPage = () => {
  const navigate = useNavigate();
  const courseInfo = JSON.parse(localStorage.getItem("courseInfo") || "{}");
  const url = "https://www.youtube.com/uarNiSl_uh4?si=6oSQmpVlu_9Odbl8";
  const [loading, setLoading] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [openRegistration, setOpenRegistration] = useState(false);
  const [videoURL, setVideoURL] = useState("");
  const [autorList, setAuthorList] = useState<string[]>([]);
  const [openForm, setOpenForm] = useState(false);
  const item = {
    id: courseInfo.id,
    head: courseInfo.title,
    description:
      courseInfo.description ||
      "Курс предназначен для студентов, желающих овладеть ключевыми навыками управления и маркетинга в спортивной сфере.",

    course_details: courseInfo.course_details,
    access_type: courseInfo.access_type,
    duration: courseInfo.duration || "3 месяца",
    hours: courseInfo.hours || "300",
    track_list: courseInfo.track_list,
    document_name: courseInfo.document_name || "о повышении квалификации",
    layout: courseInfo.layout,
    background_color: courseInfo.background_color,
    suitable: courseInfo.suitable,
    course_video: courseInfo.course_video,
  };
  const [moduleList, setModuleList] = useState<DirectusModuleInterface[]>([]);
  const [paidModuleList, setPaidModuleList] = useState<
    DirectusModuleInterface[]
  >([]);

  const fetchModules: any = Collection.readCollection("Modules") || [];

  const fetchAuthorList: any = Collection.readCollection("Authors") || [];

  const fetchBond = async () => {
    try {
      return await directus.request(
        readItems(`Authors_Course_3`, { limit: -1 })
      );
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  async function fetchAuthors() {
    const autohrs = [...(await fetchAuthorList)];

    const bondList = [...(await fetchBond())];

    let coursesList:
      | Record<string, any>
      | { id: number; Authors_id: number; Course_id: number }[] = [];

    bondList.forEach((bond) => {
      if (bond.Course_id === item.id) {
        coursesList.push(bond);
      }
    });

    let nameList: string[] = autohrs
      .map((author) => {
        const matchingCourse = coursesList.find(
          (item: { Authors_id: number }) => item.Authors_id === author.id
        );
        return matchingCourse ? author.name : null;
      })
      .filter((name) => name !== null);

    setAuthorList(nameList);
  }

  async function fetchSortedModules() {
    setLoading(true);
    const testList = courseInfo?.modules || [];

    const commonModuleList = await fetchModules;

    let rawList: DirectusModuleInterface[] | Record<string, any> = [];
    let rawPaidList: DirectusModuleInterface[] | Record<string, any> = [];

    testList?.forEach((item: number) => {
      commonModuleList?.forEach(
        (module: { id: number; price_type: string | null }) => {
          if (module.id === item) {
            if (module.price_type === "free" || module.price_type === null) {
              rawList.push(module);
              // setModuleList((previos) => [...previos, module]);
            } else {
              rawPaidList.push(module);
              // setPaidModuleList((previos) => [...previos, module]);
            }
          }
        }
      );
    });

    setModuleList([
      ...rawList.sort(
        (a: DirectusModuleInterface, b: DirectusModuleInterface) =>
          a.module_priority > b.module_priority ? 1 : -1
      ),
    ]);

    setPaidModuleList([
      ...rawPaidList.sort(
        (a: DirectusModuleInterface, b: DirectusModuleInterface) =>
          a.module_priority > b.module_priority ? 1 : -1
      ),
    ]);

    setLoading(false);
  }

  useEffect(() => {
    fetchSortedModules();
    fetchAuthors();
  }, []);

  useEffect(() => {
    const urlParts = url.split("/");
    if (urlParts.length > 3) {
      urlParts.splice(3, 0, "embed");

      setVideoURL(urlParts.join("/"));
    } else {
      return;
    }
  }, []);

  return (
    <div className="coursesListPage">
      <CourseHeadBlock
        id={item.id}
        title={item.head}
        description={item.description}
        duration={item.duration}
        hours={item.hours}
        document_name={item.document_name}
        layout={item.layout}
        background_color={item.background_color}
      />
      <div className="courseAuthorBlock">
        <div className="courseVidoBox">
          {item.course_video && (
            <iframe
              title="autorVideo"
              src={item.course_video}
              allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
              allowFullScreen
            ></iframe>
          )}
        </div>
        <div className="coldLetter authorBlockText">
          <div className="authorNameBlock">
            {autorList.length > 0 ? (
              <>
                {" "}
                {autorList.length > 1 ? (
                  <span>Авторы курса</span>
                ) : (
                  <span>Автор курса</span>
                )}
                {autorList.map((item) => (
                  <h3>{item}</h3>
                ))}
              </>
            ) : null}
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: courseInfo.course_details }}
          ></div>
        </div>
      </div>
      <div className="courseTrackBlock">
        <div className="trackBlock">
          <div className="trackBlockHead">
            <h1>Трек курса</h1>
            <label>Формат и этапы обучения</label>
          </div>
          <div className="trackGraphBlock">
            <div className="trackVericalLine"></div>
            <div className="trackBlockContent">
              {item.track_list.map((item: { track: string }) => (
                <TrackBlock html={item.track} />
              ))}
            </div>
          </div>
        </div>
        <div className="stageBlock">
          {item.access_type === "free" ? (
            <div className="stageBox">
              <h2 className="stageHead">Курс состоит из одного этапа</h2>
              <div className="stageContent">
                <StageBlock
                  img={qr}
                  text="Начальный"
                  description="Базовая часть курса с получением электорнного сертификата"
                />
              </div>
            </div>
          ) : (
            <div className="stageBox">
              <h2 className="stageHead">Курс состоит из двух этапов</h2>
              <div className="stageContent">
                <StageBlock
                  img={qr}
                  text="Начальный"
                  description="Базовая часть курса с получением электорнного сертификата"
                />
                <StageBlock
                  img={medal}
                  text="Продвинутый"
                  description="Платное обучение с получением удостоверения о повышении квалификации"
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="courseProgramBlock">
        <div className="targetBlock">
          <h1>Кому подойдет этот курс</h1>
          <div className="targetList">
            {item.suitable?.map((item: { suitable_item: string }) => (
              <div className="target">{item.suitable_item}</div>
            ))}
            {/* <div className="target">
              Специалисты по маркетингу спортивных учреждений
            </div>
            <div className="target">Руководители спортивных учреждений</div>
            <div className="target">Начинающие специалисты</div> */}
          </div>
          <div className="targetStartBox">
            <div className="targetStartImage"></div>
            <div className="targetStartContent">
              <label className="targetStartText">
                Перед началом прохождения курса рекомендуем пройти анонимное
                онлайн-тестирование на определение профессиональных компетенций
              </label>
              <StyledButton
                text="НАЧАТЬ ТЕСТИРОВАНИЕ"
                onClick={(e: boolean) => setOpenForm(e)}
              />
            </div>
          </div>
        </div>
        <div
          className={
            item.track_list.length > 3
              ? "programBlock longTrack"
              : "programBlock"
          }
        >
          <h1>Программа курса</h1>
          <span>
            Вас ждут видео экспертов с подробной теорией и практические работы
            на основе реальных задач из практики маркетологов.
          </span>
          <div className="programModuleList">
            <div className="freeModule">
              <div className="modulePriceBox">
                <div className="modulePrice">Бесплатно</div>
              </div>
              {moduleList.map((module, index) => {
                return (
                  <ModuleBlock
                    key={index}
                    number={module.title}
                    description={module.module_name}
                  />
                );
              })}
            </div>{" "}
            {item.access_type !== "free" && (
              <div className="paidModule">
                <div className="modulePriceBox">
                  <div className="modulePrice">{courseInfo.price} ₽</div>
                </div>
                {paidModuleList.map((module, index) => {
                  return (
                    <ModuleBlock
                      key={index}
                      number={module.title}
                      description={module.module_name}
                    />
                  );
                })}
              </div>
            )}
          </div>
          <StyledButton
            text="НАЧАТЬ ОБУЧЕНИЕ"
            className="blueButton programListButton"
            onClick={() => {
              if (sessionStorage.getItem("token")) {
                window.scrollTo(0, 0);
                navigate("/modules");
              } else {
                setOpenLogin(true);
              }
            }}
          />
        </div>
      </div>
      {openForm && !sessionStorage.getItem("token") && (
        <TestForm close={(e: boolean) => setOpenForm(e)} />
      )}
      {openForm && sessionStorage.getItem("token") && (
        <LoggedTestForm close={(e: boolean) => setOpenForm(e)} />
      )}
      {openLogin && (
        <Login
          close={(e: boolean) => setOpenLogin(e)}
          reg={(e: boolean) => setOpenRegistration(e)}
        />
      )}
      {openRegistration && (
        <Registration
          close={(e: boolean) => setOpenRegistration(e)}
          login={(e: boolean) => setOpenLogin(e)}
        />
      )}
    </div>
  );
};

export default CourseDescriptionPage;
